import { useAppConfig } from "~/app/config/useAppConfig";
import { resolveUrl } from "../../../utils/url/urlResolver";
import { BottomNavigationItem } from "~/features/BottomNavigation/BottomNavigation";
import { CART_PAGE } from "~/utils/url/staticUrls";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectMinicartData } from "~/features/cart/minicart/minicartRedux";
import { userIsCustomer } from "~/domains/user/utils/roles";
import { PersonalNavItem } from "~/features/navigation/components/headerMenu/PersonalNavItem";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { formatCurrency } from "~/common/utils/currencyFormatter";

function useMinicartLogic() {
  const { count, priceValue, currencyIso, show, url } = useSelector(selectMinicartData);
  const webservicesDisabled = useAppConfig()?.configuration.disableAllWS ?? false;
  const totalStr = webservicesDisabled ? "-" : getPriceLabel(priceValue, currencyIso, count);

  return {
    totalStr,
    url: resolveUrl(url),
    isActive: window.location.pathname.endsWith(CART_PAGE),
    show,
    count,
  };
}

export const HeaderMinicart = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { show, totalStr, url, count } = useMinicartLogic();

  if (!show) {
    return null;
  }

  let extraProps;
  if (userIsCustomer()) {
    extraProps = {
      label: totalStr,
    };
  } else {
    extraProps = {
      badgeContent: count,
    };
  }

  return (
    <a href={url} className={className} aria-label={t("breadcrumb.cart")}>
      <PersonalNavItem {...extraProps} icon={<ShoppingCartOutlinedIcon />} name={t("header.link.cart")} />
    </a>
  );
};
export const MobileMinicart = () => {
  const { show, totalStr, count, url, isActive } = useMinicartLogic();
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  let extraProps;
  if (userIsCustomer()) {
    extraProps = {
      name: totalStr,
    };
  } else {
    extraProps = {
      name: t("breadcrumb.cart"),
      quantity: count,
    };
  }

  return (
    <a href={url} aria-label={t("breadcrumb.cart")}>
      <BottomNavigationItem {...extraProps} icon={<ShoppingCartOutlinedIcon />} isActive={isActive} />
    </a>
  );
};

const getPriceLabel = (priceValue: number | undefined, currencyIso: string | undefined, qty: number) => {
  if (priceValue === undefined || currencyIso === undefined) {
    return "-";
  }
  return qty > 0 ? formatCurrency(priceValue, currencyIso) : "-";
};
